var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-theme-circle width-xs",class:_vm.buttonClass,attrs:{"type":"button"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"mdi mdi-delete font-size-14 align-middle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }